import { Link } from "react-router-dom";

export const inputStyle = {
  width: "100%",
  padding: "0.85rem 1rem",
  borderRadius: 10,
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(212, 175, 55, 0.25)",
  color: "#F4F6F0",
  fontFamily: "Outfit, sans-serif",
  fontSize: "0.95rem",
  outline: "none",
};

export const labelStyle = {
  display: "block",
  fontSize: "0.8rem",
  color: "#A0A0B0",
  marginBottom: "0.4rem",
  fontFamily: "Outfit, sans-serif",
};

export const errorStyle = {
  color: "#E0115F",
  fontSize: "0.85rem",
  margin: "0.75rem 0 0",
  lineHeight: 1.5,
};

export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        background: "radial-gradient(circle at 50% 30%, #14102A 0%, #03030A 70%)",
        color: "#F4F6F0",
        fontFamily: "Outfit, system-ui, sans-serif",
      }}
    >
      <div className="mandala-watermark" />
      <div className="grain-overlay" />

      <div
        className="glass-panel"
        style={{
          maxWidth: 420,
          width: "100%",
          padding: "2.75rem 2.25rem",
          borderRadius: 22,
          position: "relative",
          zIndex: 3,
        }}
      >
        <Link
          to="/"
          className="subtitle-caps"
          style={{ textDecoration: "none", display: "inline-block", marginBottom: "1.75rem" }}
        >
          ← Mind Kundli
        </Link>

        <h1 className="serif" style={{ fontSize: "1.9rem", margin: "0 0 0.5rem", fontWeight: 500 }}>
          {title}
        </h1>
        {subtitle && (
          <p style={{ color: "#A0A0B0", lineHeight: 1.55, margin: "0 0 2rem", fontSize: "0.95rem" }}>
            {subtitle}
          </p>
        )}

        {children}

        {footer && <div style={{ marginTop: "1.75rem", textAlign: "center" }}>{footer}</div>}
      </div>
    </div>
  );
}
